import $ from "jquery";
import app from "../src/App";
import "./newsletter";

const $burger = $(".js-burger");
const $menuItems = $(".main-menu-list .menu-item a, .main-menu__underlay, .main-menu-close");

function toggleMenu() {
  const $body = $("body");
  $body.toggleClass("menu--open");

  if ($body.hasClass("menu--open")) {
    app.scrollBlock("menu");
  } else {
    app.scrollUnblock("menu");
  }
}

$burger.on("click", toggleMenu);

$menuItems.on("click", function () {
  if ($("body").hasClass("menu--open") && !$(this).hasClass("menu-item-type-post_type")) {
    toggleMenu();
  }
});

let isScrolled = false;
let triggerPoint = Math.ceil(window.innerHeight / 1.5);

$(window).on("scroll", () => {
  const scrollTop = $(window).scrollTop();

  if (scrollTop > triggerPoint && !isScrolled) {
    $("body").addClass("page--scrolled newsletter-banner-open");
    isScrolled = true;
  } else if (scrollTop === 0 && isScrolled) {
    $("body").removeClass("page--scrolled newsletter-banner-open");
    isScrolled = false;
  }
});

function debounce(func, timeout = 300) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), timeout);
  };
}

const initializeHeaderScroll = () => {
  const $siteHeader = $(".site-header");
  let lastScrollTop = 0;

  $(window).on(
    "scroll",
    debounce(() => {
      const currentScroll = $(window).scrollTop();

      if (currentScroll > lastScrollTop && currentScroll > window.innerHeight) {
        // User is scrolling down and past one screen height
        $siteHeader.addClass("hidden");
      } else if (currentScroll < lastScrollTop) {
        // User is scrolling up
        $siteHeader.removeClass("hidden");
      }

      lastScrollTop = currentScroll;
    }, 50),
  );
};

initializeHeaderScroll();
